export var removeDuplicate = function (field) { return (Array.isArray(field) ? field[0] : field); };
//# sourceMappingURL=index.js.map